(() => {
  const themeRoutes = window.routes || {};
  const pendingDiscountsByVariant = new Map();

  const getSections = (drawer) => {
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return ['cart-drawer', 'cart-icon-bubble'];

    return drawer.getSectionsToRender().map((section) => section.id);
  };

  const getJsonRoute = (route, fallback) => {
    const value = String(route || fallback || '').trim();
    if (!value) return fallback;

    const queryIndex = value.indexOf('?');
    const path = queryIndex === -1 ? value : value.slice(0, queryIndex);
    const query = queryIndex === -1 ? '' : value.slice(queryIndex);

    if (path.endsWith('.js')) return value;

    return `${path.replace(/\/$/, '')}.js${query}`;
  };

  const cartUpdateUrl = getJsonRoute(themeRoutes.cart_update_url, '/cart/update.js');
  const cartUrl = getJsonRoute(themeRoutes.cart_url, '/cart.js');

  const fetchCart = async () => {
    const response = await fetch(cartUrl, {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) throw new Error('Unable to validate the current cart.');

    return response.json();
  };

  const getCartDiscountCodes = (cart) => {
    if (!Array.isArray(cart?.discount_codes)) return [];

    return cart.discount_codes
      .map((discount) => String(discount.code || '').trim())
      .filter(Boolean);
  };

  const applyDiscountCode = async (discountCode, sectionIds) => {
    const code = String(discountCode || '').trim();
    if (!code) return null;

    let existingCodes = [];
    try {
      existingCodes = getCartDiscountCodes(await fetchCart());
    } catch (error) {
      existingCodes = [];
    }

    const discountCodes = Array.from(new Set([...existingCodes, code]));
    const response = await fetch(cartUpdateUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        discount: discountCodes.join(','),
        sections: sectionIds,
        sections_url: window.location.pathname,
      }),
    });

    if (!response.ok) return null;

    try {
      return await response.json();
    } catch (error) {
      return null;
    }
  };

  const getFormVariantId = (form) => {
    if (!(form instanceof HTMLFormElement)) return '';

    return String(new FormData(form).get('id') || '').trim();
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      const productForm = form?.closest?.('product-form[data-kronk-cart-upsell-discount-code]');
      if (!productForm) return;

      const variantId = getFormVariantId(form);
      const discountCode = String(productForm.dataset.kronkCartUpsellDiscountCode || '').trim();
      if (!variantId || !discountCode) return;

      pendingDiscountsByVariant.set(variantId, discountCode);
    },
    true
  );

  const onCartUpdate = async (event) => {
    if (!event || event.source !== 'product-form') return;

    const variantId = String(event.productVariantId || '').trim();
    const discountCode = pendingDiscountsByVariant.get(variantId);
    if (!discountCode) return;

    pendingDiscountsByVariant.delete(variantId);

    const drawer = document.querySelector('cart-drawer');
    const sectionIds = getSections(drawer);
    let discountData = null;

    try {
      discountData = await applyDiscountCode(discountCode, sectionIds);
    } catch (error) {
      return;
    }

    if (discountData?.sections && drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(discountData);
    }
  };

  const onCartError = (event) => {
    if (!event || event.source !== 'product-form') return;

    const variantId = String(event.productVariantId || '').trim();
    if (variantId) pendingDiscountsByVariant.delete(variantId);
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    subscribe(PUB_SUB_EVENTS.cartError, onCartError);
  }
})();
